import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// /accept-invite is deprecated in favour of /invite-setup. The old page
// called verifyOtp on mount which let link-protection prefetchers
// (Microsoft Safe Links / Mimecast) consume single-use invite tokens
// before the user clicked. /invite-setup defers verifyOtp until the user
// explicitly accepts.
//
// We keep the route alive as a redirect rather than deleting it because
// the path may be referenced in old emails, CRM templates, or external
// docs that we don't control. Search + hash are forwarded verbatim so
// the destination receives the same token_hash / access_token params.
const AcceptInvite = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const search = window.location?.search || '';
    const hash = window.location?.hash || '';
    navigate(`/invite-setup${search}${hash}`, { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-500 mx-auto mb-4"></div>
        <p className="text-slate-300 text-sm">Loading your invitation…</p>
      </div>
    </div>
  );
};

export default AcceptInvite;
